import { createAction } from '@reduxjs/toolkit';

export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE';
export const clearErrorMessage = createAction<undefined>(CLEAR_ERROR_MESSAGE);
